// 求人編集画面の特徴選択時に、最大個数以上の特徴を選択できないようにする

$(() => {
  const $container = $('.js-feature-select');
  // Job::MAX_JOB_FEATURES_LENGTH
  const maxJobFeaturesLength = 15;
  const relativeFeatureMap = {
    2: [15, 5, 12], // 『週1〜2日から』-> 『週3〜4日から』『シフト応相談』『扶養控除内OK』
    3: [12], // 『1日4h以内OK』 -> 『扶養控除内OK』
    12: [1], // 『扶養控除内OK』->『主夫歓迎』
    13: [1], // 『託児所あり』->『主夫歓迎』
    15: [5], // 『週3〜4日から』->『シフト応相談』
    19: [10], // 『高校生歓迎』->『学生歓迎』
  };

  const isMaxCheck = () => {
    if ($container.find('input[type=checkbox]:checked').length >= maxJobFeaturesLength) {
      $container.find('input[type=checkbox]:not(:checked)').prop('disabled', true);
      return true;
    }
    return false;
  };

  $container.on('change', 'input[type=checkbox]', e => {
    const $checkbox = $(e.currentTarget);
    if ($checkbox.prop('checked')) {
      if (isMaxCheck()) return;

      const relativeFeatures = relativeFeatureMap[$checkbox.val()];
      if (relativeFeatures) {
        for (let i = 0; i < relativeFeatures.length; i += 1) {
          const relativeCheckbox = $container.find(`input[value=${relativeFeatures[i]}]`);
          relativeCheckbox.prop('checked', true);
          if (isMaxCheck()) return;
        }
      }
    } else {
      $container.find('input[type=checkbox]').prop('disabled', false);
    }
  });
});
